<template>
  <div>
    <div class="border-dashboard" style="background-color: #f7f7f7; height: 100%">
      <div style="font-size: 20px" class="pt-6 mx-6 pb-4 border-dashboard-bottom">Have questions?</div>
      <div class="py-6 px-6">
        <div class="pb-6 text-accelerate-grey-1 text-body-2">
          Check out our
          <a
            class="my-support-contact-text text-decoration-underline"
            href="https://ulc.asu.edu/help-center/faqs/"
            target="_blank"
            @click="asuoDataLayerClick('accelerateDashboard', '5', { text: 'faq' })"
            >FAQ</a
          >. If you don’t find answers you’re looking for, we’re here to help! Success Coaches are available Monday
          through Friday, 7 a.m. to 6 p.m. MST.
        </div>
        <div class="ml-3">
          <div class="mb-4">
            <v-icon class="mr-3" size="18">mdi-email</v-icon>
            <a
              class="my-support-contact-text text-decoration-underline"
              href="mailto:ulcourses@asu.edu"
              @click="handleOpenEmail()"
              >ulcourses@asu.edu</a
            >
          </div>
          <div class="mb-4" style="display: flex">
            <v-icon class="mr-3" size="18">mdi-phone</v-icon>
            <p class="mb-0">844-448-7707</p>
          </div>
          <div class="mb-4">
            <img :src="supportChatIcon" class="mr-4" />
            <a class="my-support-contact-text text-decoration-underline" @click="openChat()">Live chat</a>
          </div>
        </div>
        <div class="text-accelerate-grey-1 text-caption">
          Feel free to leave messages after business hours — we’ll follow up with you as soon as we’re back online.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import supportChatIcon from '@/assets/icons/support-chat-icon.svg';

import { DataLayerMixin } from '../../mixins/dataLayerMixin';
export default defineComponent({
  mixins: [DataLayerMixin],
  name: 'MySupportCard',

  data() {
    return {
      supportChatIcon
    };
  },

  methods: {
    handleOpenEmail() {
      this.asuoDataLayerClick('accelerateDashboard', '5');
    },
    openChat() {
      this.asuoDataLayerClick('accelerateDashboard', '6');
      const getChatIcon = document.getElementsByClassName('chat-message-icon');
      if (getChatIcon.length > 0) {
        getChatIcon[0].click();
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.my-support-contact-text {
  color: #8c1d40;
}
.text-decoration-underline {
  text-decoration: underline;
}
</style>
